export default "__VITE_ASSET__DfLyarv1__"